import type { SidebarItem } from "@/types/proxima-design-system";
import { USER_ROLES } from "../enums/USER_ROLES";
import { PERMISSIONS } from "../enums/PERMISSIONS";
import { PATH } from "../constants/path";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "../configs/rolesAndPermissionsMappingOnRoutes";

import storeAppsModulesConfig from "../../../modules-config.json";
import { StoreAppModule } from "@/store/type";

const enabledModulesNames: string[] = (
  (import.meta.env.VITE_APP_MODULES as string) ?? ""
).split(",");

const enabledModulesConfig = (
  storeAppsModulesConfig as StoreAppModule[]
).filter(
  (module) => enabledModulesNames.includes(module.name) || module.isBase,
);

const sidebarItems: SidebarItem<USER_ROLES, PERMISSIONS>[] = [
  {
    label: "Dashboard",
    active: false,
    icon: "m-dashboard",
    children: [],
    pageTitle: "Overview",
    path: PATH.DASHBOARD,
    roles: ROLES_AND_PERMISSION_ON_ROUTES.DASHBOARD.ROLES,
    permissions: ROLES_AND_PERMISSION_ON_ROUTES.DASHBOARD.PERMISSIONS,
    module: "dashboardModule",
  },
  {
    label: "Sell",
    active: false,
    children: [
      {
        label: "Flights",
        active: false,
        icon: "m-flight",
        children: [],
        pageTitle: "Book Flights",
        path: PATH.FLIGHTS,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.FLIGHTS.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.FLIGHTS.PERMISSIONS,
        module: "flightModule",
      },
      {
        label: "Hotels",
        active: false,
        icon: "m-hotel",
        children: [],
        pageTitle: "Book Hotels",
        path: PATH.HOTELS,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.HOTELS.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.HOTELS.PERMISSIONS,
        module: "hotelModule",
      },
      {
        label: "Group Flights",
        active: false,
        icon: "m-group-flights",
        children: [],
        pageTitle: "Group Flights",
        path: PATH.FDG_FLIGHTS,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.FDG_FLIGHTS.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.FDG_FLIGHTS.PERMISSIONS,
        module: "fDGModule",
      },
      {
        label: "Umrah / Ziarat",
        active: false,
        icon: "m-umrah-ziarat",
        children: [],
        pageTitle: "Book Umrah Trips",
        path: PATH.FDG_UMRAH,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.FDG_UMRAH.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.FDG_UMRAH.PERMISSIONS,
        module: "fDGModule",
      },
      {
        label: "Umrah Hotels",
        active: false,
        icon: "m-hotel",
        children: [],
        pageTitle: "Book Umrah Hotels",
        path: PATH.FIT_HOTELS,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.FIT.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.FIT.PERMISSIONS,
        module: "fITModule",
      },
      {
        label: "My Bookings",
        active: false,
        icon: "m-my-bookings",
        children: [],
        pageTitle: "My Bookings",
        path: PATH.MY_BOOKINGS,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.MY_BOOKINGS.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.MY_BOOKINGS.PERMISSIONS,
        module: "myBookingsModule",
      },
      {
        label: "My Issuances",
        active: false,
        icon: "m-my-bookings",
        children: [],
        pageTitle: "My Issuances",
        path: PATH.MY_ISSUANCE,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.MY_ISSUANCES.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.MY_ISSUANCES.PERMISSIONS,
        module: "myIssuancesModule",
      },
      {
        label: "Check Churning",
        active: false,
        icon: "m-warning",
        children: [],
        badge: "NEW",
        pageTitle: "Check Churning",
        path: PATH.CHURNING,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.CHURNING.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.CHURNING.PERMISSIONS,
        module: "churningModule",
      },
      {
        label: "Issue Ticket",
        active: false,
        icon: "m-issue-ticket",
        children: [],
        pageTitle: "Issue Ticket",
        path: PATH.FLIGHT_ISSUANCE,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.FLIGHT_ISSUANCE.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.FLIGHT_ISSUANCE.PERMISSIONS,
        module: "flightIssuanceModule",
      },
      {
        label: "Deals / Promos",
        active: false,
        icon: "m-deals-and-promos",
        children: [],
        badge: "NEW",
        pageTitle: "Deals And Promotions",
        path: PATH.DEALS_AND_PROMOS,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.DEALS_AND_PROMOS.ROLES,
        permissions:
          ROLES_AND_PERMISSION_ON_ROUTES.DEALS_AND_PROMOS.PERMISSIONS,
        module: "dealsModule",
      },
      {
        label: "Refunds",
        active: false,
        icon: "m-currency-conversion",
        children: [],
        pageTitle: "Refund PNR",
        path: PATH.FLIGHT_REFUNDS,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.FLIGHT_REFUNDS.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.FLIGHT_REFUNDS.PERMISSIONS,
        module: "flightRefundsModule",
      },
      {
        label: "Fare Management",
        active: false,
        icon: "m-fare-management",
        children: [],
        pageTitle: "Fare Management",
        path: PATH.FARE_MANAGEMENT,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.FARE_MANAGEMENT.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.FARE_MANAGEMENT.PERMISSIONS,
        module: "fareManagementModule",
      },
      {
        label: "Sabre Segment",
        active: false,
        icon: "m-sabre-segment",
        children: [],
        pageTitle: "My Sabre Segments",
        path: PATH.SABRE_SEGMENT,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.SABRE_SEGMENT.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.SABRE_SEGMENT.PERMISSIONS,
        module: "sabreSegmentModule",
      },
      {
        label: "Issuance Logs",
        active: false,
        icon: "m-issuance-logs",
        children: [],
        pageTitle: "Issuance Records",
        path: PATH.ISSUANCE_LOGS_WITHOUT_PNR,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.ISSUANCE_LOGS.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.ISSUANCE_LOGS.PERMISSIONS,
        module: "issuanceLogsModule",
      },
      {
        label: "Manage Quotations",
        active: false,
        icon: "m-qoutation-management",
        children: [],
        pageTitle: "Quotations Management",
        path: PATH.MANAGE_QUOTATIONS,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.MANAGE_QUOTATIONS.ROLES,
        permissions:
          ROLES_AND_PERMISSION_ON_ROUTES.MANAGE_QUOTATIONS.PERMISSIONS,
        module: "manageQuotationsModule",
      },
      {
        label: "Ok To Board",
        active: false,
        icon: "m-issue-ticket",
        children: [],
        badge: "NEW",
        pageTitle: "Ok To Board",
        path: PATH.VISA_VERIFICATION,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.VISA_VERIFICATION.ROLES,
        permissions:
          ROLES_AND_PERMISSION_ON_ROUTES.VISA_VERIFICATION.PERMISSIONS,
        module: "visaVerificationModule",
      },
    ],
  },
  {
    label: "Organization Management",
    active: false,
    children: [
      {
        label: "User Management",
        active: false,
        icon: "m-agent-management",
        children: [],
        pageTitle: "User Management",
        path: PATH.AGENT_MANAGEMENT,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.AGENT_MANAGEMENT.ROLES,
        permissions:
          ROLES_AND_PERMISSION_ON_ROUTES.AGENT_MANAGEMENT.PERMISSIONS,
        module: "agentModule",
      },
      {
        label: "Organizations",
        active: false,
        icon: "m-organisations",
        children: [],
        pageTitle: "Organizational Tools",
        path: PATH.ORGANIZATION,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.ORGANIZATION.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.ORGANIZATION.PERMISSIONS,
        module: "organizationModule",
      },
      {
        label: "Employee Grades",
        active: false,
        icon: "m-badge",
        children: [],
        pageTitle: "Employee Grades Management",
        path: PATH.EMPLOYEE_GRADE,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.EMPLOYEE_GRADE.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.EMPLOYEE_GRADE.PERMISSIONS,
        module: "employeeGradeModule",
      },
      {
        label: "Cost Centers",
        active: false,
        icon: "m-local-atm",
        children: [],
        pageTitle: "Cost Centers",
        path: PATH.COST_CENTER,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.COST_CENTER.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.COST_CENTER.PERMISSIONS,
        module: "costCenterModule",
      },
      {
        label: "Departments",
        active: false,
        icon: "m-organisations",
        children: [],
        pageTitle: "Departments Management",
        path: PATH.DEPARTMENT,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.DEPARTMENT.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.DEPARTMENT.PERMISSIONS,
        module: "departmentModule",
      },
      {
        label: "Corporate Policies",
        active: false,
        icon: "m-verified-user",
        children: [],
        pageTitle: "Corporate Policies",
        path: PATH.CORPORATE_POLICY,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.CORPORATE_POLICY.ROLES,
        permissions:
          ROLES_AND_PERMISSION_ON_ROUTES.CORPORATE_POLICY.PERMISSIONS,
        module: "corporatePolicyModule",
      },
      {
        label: "Approval Workflow",
        active: false,
        icon: "m-status",
        children: [],
        pageTitle: "Approval Workflow",
        path: PATH.APPROVAL_SYSTEM,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.APPROVAL_SYSTEM.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.APPROVAL_SYSTEM.PERMISSIONS,
        module: "approvalSystemModule",
      },
      {
        label: "Details",
        active: false,
        icon: "m-details",
        children: [],
        pageTitle: "Details View",
        path: "ORGANISATION_DETAILS_PATH",
        roles: ROLES_AND_PERMISSION_ON_ROUTES.ORGANIZATION_DETAIL.ROLES,
        permissions:
          ROLES_AND_PERMISSION_ON_ROUTES.ORGANIZATION_DETAIL.PERMISSIONS,
        module: "organizationModule",
      },
      {
        label: "Preferences",
        active: false,
        icon: "m-preferences",
        children: [],
        pageTitle: "Organization Preferences",
        path: PATH.PREFERENCE,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.PREFERENCE.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.PREFERENCE.PERMISSIONS,
        module: "organizationModule",
      },
      {
        label: "Website Management",
        active: false,
        icon: "m-website-management",
        children: [],
        pageTitle: "Website Management",
        path: PATH.WEBSITE_MANAGEMENT,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.WEBSITE_MANAGEMENT.ROLES,
        permissions:
          ROLES_AND_PERMISSION_ON_ROUTES.WEBSITE_MANAGEMENT.PERMISSIONS,
        module: "websitemanagementModule",
      },
      {
        label: "Passenger Management",
        active: false,
        icon: "m-passenger-management",
        children: [],
        pageTitle: "Passenger Management",
        path: PATH.PASSENGER_MANAGEMENT,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.PASSENGER_MANAGEMENT.ROLES,
        permissions:
          ROLES_AND_PERMISSION_ON_ROUTES.PASSENGER_MANAGEMENT.PERMISSIONS,
        module: "organizationModule",
      },
      {
        label: "Whatsapp Management",
        active: false,
        icon: "m-send-message",
        children: [],
        pageTitle: "Messaging",
        path: PATH.WHATSAPP_MANAGEMENT,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.WHATSAPP_MANAGEMENT.ROLES,
        permissions:
          ROLES_AND_PERMISSION_ON_ROUTES.WHATSAPP_MANAGEMENT.PERMISSIONS,
        module: "whatsappManagementModule",
      },
      {
        label: "Self Onboarding Organizations",
        active: false,
        icon: "m-organisations",
        children: [],
        pageTitle: "Onboarding Progress",
        path: PATH.SAAS_ELITE_ORGANIZATION,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.SAAS_ORGANIZATIONS.ROLES,
        permissions:
          ROLES_AND_PERMISSION_ON_ROUTES.SAAS_ORGANIZATIONS.PERMISSIONS,
        module: "selfOnboardingOrganizationsModule",
      },
    ],
  },
  {
    label: "Policies",
    active: false,
    children: [
      {
        label: "My Policy",
        active: false,
        icon: "m-admin-panel-settings",
        children: [],
        pageTitle: "My Policy",
        path: PATH.MY_POLICIES,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.MY_POLICIES.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.MY_POLICIES.PERMISSIONS,
        module: "corporatePolicyModule",
      },
    ],
  },
  {
    label: "Approvals",
    active: false,
    children: [
      {
        label: "My Approvals",
        active: false,
        icon: "m-pending",
        children: [],
        pageTitle: "My Approvals",
        path: PATH.MY_APPROVALS,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.MY_APPROVALS.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.MY_APPROVALS.PERMISSIONS,
        module: "approvalRequestsModule",
        feature: "my-approvals",
      },
      {
        label: "Assigned Approvals",
        active: false,
        icon: "m-status",
        children: [],
        pageTitle: "Assigned Approvals",
        path: PATH.ASSIGNED_APPROVALS,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.ASSIGNED_APPROVALS.ROLES,
        permissions:
          ROLES_AND_PERMISSION_ON_ROUTES.ASSIGNED_APPROVALS.PERMISSIONS,
        module: "approvalRequestsModule",
        feature: "assigned-approvals",
      },
      {
        label: "Approval Delegation",
        active: false,
        icon: "m-supervisor-account",
        children: [],
        pageTitle: "Approval Delegation",
        path: PATH.APPROVAL_DELEGATION,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.APPROVAL_DELEGATION.ROLES,
        permissions:
          ROLES_AND_PERMISSION_ON_ROUTES.APPROVAL_DELEGATION.PERMISSIONS,
        module: "approvalRequestsModule",
        feature: "approval-delegation",
      },
    ],
  },
  {
    label: "Finance",
    active: false,
    children: [
      {
        label: "Payment Management",
        active: false,
        icon: "m-payment-management",
        children: [],
        pageTitle: "Payment Handling",
        path: PATH.PAYMENTS,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.PAYMENTS.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.PAYMENTS.PERMISSIONS,
        module: "paymentsModule",
      },
      {
        label: "Credit Limit Management",
        active: false,
        icon: "m-credit-limit-management",
        children: [],
        pageTitle: "Credit Control",
        path: PATH.CREDIT_LIMIT_MANAGEMENT,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.CREDIT_LIMIT_MANAGEMENT.ROLES,
        permissions:
          ROLES_AND_PERMISSION_ON_ROUTES.CREDIT_LIMIT_MANAGEMENT.PERMISSIONS,
        module: "creditLimitManagementModule",
      },
      {
        label: "Statement Of Accounts",
        active: false,
        icon: "m-soa",
        children: [],
        pageTitle: "Account Statements",
        path: PATH.SOA,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.SOA.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.SOA.PERMISSIONS,
        module: "soaModule",
      },
      {
        label: "Pricing",
        active: false,
        icon: "m-ag-pricing",
        children: [],
        pageTitle: "Pricing",
        path: PATH.PRICING,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.PRICING.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.PRICING.PERMISSIONS,
        module: "pricingModule",
      },
      {
        label: "Currency Conversion",
        active: false,
        icon: "m-currency-conversion",
        children: [],
        pageTitle: "Currency Conversion",
        path: PATH.CURRENCY_CONVERSION,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.CURRENCY_CONVERSION.ROLES,
        permissions:
          ROLES_AND_PERMISSION_ON_ROUTES.CURRENCY_CONVERSION.PERMISSIONS,
        module: "currencyConversionModule",
      },
    ],
  },
  {
    label: "Reports",
    active: false,
    children: [
      {
        label: "Daily Issuance",
        active: false,
        icon: "m-daily-issuance",
        children: [],
        pageTitle: "Issuance Overview",
        path: PATH.DAILY_ISSUANCE,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.DAILY_ISSUANCE.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.DAILY_ISSUANCE.PERMISSIONS,
        module: "dailyIssuanceModule",
      },
      {
        label: "Sales Snapshot",
        active: false,
        icon: "m-sales-snapshot",
        children: [],
        pageTitle: "Sales Insights",
        path: PATH.SALES_SNAPSHOT,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.SALES_SNAPSHOT.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.SALES_SNAPSHOT.PERMISSIONS,
        module: "salesModule",
      },
      {
        label: "Sector Snapshot",
        active: false,
        icon: "m-sector-snapshot",
        children: [],
        pageTitle: "Sector Insights",
        path: PATH.SECTOR_SNAPSHOT,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.SECTOR_SNAPSHOT.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.SECTOR_SNAPSHOT.PERMISSIONS,
        module: "sectorModule",
      },
      {
        label: "Organization Snapshot",
        active: false,
        icon: "m-organisation-snapshot",
        children: [],
        pageTitle: "Organization Insights",
        path: PATH.ORGANIZATION_SNAPSHOT,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.ORGANIZATION_SNAPSHOT.ROLES,
        permissions:
          ROLES_AND_PERMISSION_ON_ROUTES.ORGANIZATION_SNAPSHOT.PERMISSIONS,
        module: "organizationSnapshotModule",
      },
      {
        label: "Digital Payments",
        active: false,
        icon: "m-digital-payments",
        children: [],
        pageTitle: "Digital Transactions",
        path: PATH.DIGITAL_PAYMENTS,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.DIGITAL_PAYMENTS_BY_SECTORS.ROLES,
        permissions:
          ROLES_AND_PERMISSION_ON_ROUTES.DIGITAL_PAYMENTS_BY_SECTORS
            .PERMISSIONS,
        module: "digitalPaymentsModule",
      },
    ],
  },
  {
    label: "My Team",
    active: false,
    icon: "m-my-team",
    children: [],
    pageTitle: "Team Management",
    path: PATH.MY_TEAM,
    roles: ROLES_AND_PERMISSION_ON_ROUTES.SALES_MY_TEAM.ROLES,
    permissions: ROLES_AND_PERMISSION_ON_ROUTES.SALES_MY_TEAM.PERMISSIONS,
    module: "myTeamModule",
  },
  {
    label: "More",
    active: false,
    children: [
      {
        label: "News",
        active: false,
        icon: "m-news",
        children: [],
        pageTitle: "News",
        path: PATH.NEWS,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.NEWS.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.NEWS.PERMISSIONS,
        module: "newsModule",
      },
      {
        label: "Profile",
        active: false,
        icon: "m-profile",
        children: [],
        pageTitle: "User Profile",
        path: PATH.USER_PROFILE,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.USERPROFILE.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.USERPROFILE.PERMISSIONS,
        module: "profileModule",
      },
      {
        label: "Tutorials",
        active: false,
        icon: "m-ag-tutorials",
        children: [],
        pageTitle: "Tutorials",
        path: PATH.TUTORIALS,
        roles: ROLES_AND_PERMISSION_ON_ROUTES.TUTORIALS.ROLES,
        permissions: ROLES_AND_PERMISSION_ON_ROUTES.TUTORIALS.PERMISSIONS,
        module: "tutorialsModule",
      },
    ],
  },
  {
    label: "Complete Your Application Progress",
    active: false,
    icon: "m-complete-application",
    children: [],
    pageTitle: "Application Progress",
    path: PATH.ORGANIZATION_DOCUMENTS,
    roles: ROLES_AND_PERMISSION_ON_ROUTES.COMPLETE_YOUR_APPLICATION.ROLES,
    permissions:
      ROLES_AND_PERMISSION_ON_ROUTES.COMPLETE_YOUR_APPLICATION.PERMISSIONS,
    module: "selfOnboardingOrganizationsModule",
  },
];

const enabledModulesConfigNames = enabledModulesConfig.map((config) =>
  config.storeKey ? config.storeKey : config.key,
);

const getSidebarItems = (): SidebarItem<USER_ROLES, PERMISSIONS>[] => {
  return sidebarItems.filter((item: SidebarItem<USER_ROLES, PERMISSIONS>) => {
    if (item.children && item.children.length > 0) {
      item.children = item.children.filter(
        (child: SidebarItem<USER_ROLES, PERMISSIONS>) =>
          child.module && child.module.length > 0
            ? enabledModulesConfigNames.includes(child.module)
            : true,
      );
      return item.children.length > 0;
    }

    return item.module && enabledModulesConfigNames.includes(item.module);
  });
};

const updatedSidebarItems: SidebarItem<USER_ROLES, PERMISSIONS>[] =
  getSidebarItems();

export default updatedSidebarItems;
